import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./lib/queryClient";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import { AdminLayout } from "./components/layouts/AdminLayout";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { OrganisationsPage } from "./pages/OrganisationsPage";
import { OrganisationDetailPage } from "./pages/OrganisationDetailPage";
import { BulkRolesPage } from "./pages/BulkRolesPage";
import { RolesPage } from "./pages/RolesPage";
import { NotFoundPage } from "./pages/NotFoundPage";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<AdminLayout />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/organisations" element={<OrganisationsPage />} />
              <Route path="/organisations/:id" element={<OrganisationDetailPage />} />
              <Route path="/bulk-roles" element={<BulkRolesPage />} />
              <Route path="/roles" element={<RolesPage />} />
            </Route>
          </Route>
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
